export const mapSelectOptions = (entries, {
	text = 'name',
	value = '_id',
	group = false,
} = {}) => {
	if (!group) {
		return entries.reduce((acc, entry) => [...acc, { value: entry[value], text: entry[text] }], [])
	}

	entries.sort((a, b) => (`${a[group] || ''}`).localeCompare(b[group]))
	let currentGroup = null
	return entries.reduce((acc, entry) => {
		if (currentGroup !== entry[group]) {
			if (currentGroup !== null) {
				acc.push({ divider: true })
			}
			currentGroup = entry[group]
			acc.push({ header: currentGroup })
		}

		acc.push({ value: entry[value], text: entry[text], group: entry[group] })
		return acc
	}, [])
}

export const mapFields = (entries, field, {
	key = '_id',
} = {}) => entries.reduce((acc, entry) => ({ ...acc, [entry[key]]: entry[field] }), {})

export const mapDataSourceFields = entries => mapFields(entries, 'text', { key: 'value' })

export const mapEntries = (entries, {
	key = '_id',
} = {}) => entries.reduce((acc, entry) => ({ ...acc, [entry[key]]: entry }), {})

// @TODO - Refactor
export const dynamicNewMapEntries = async (entries, foreignKey, existingMap, request, {
	key = '_id',
} = {}) => {
	if (!entries) { return { entries: [] } }

	const ids = entries.map(entry => entry[foreignKey])
	const newIds = ids.reduce((acc, id) => {
		if (id && !existingMap[id]) {
			acc.push(id)
		}
		return acc
	}, [])

	if (newIds.length) {
		try {
			const newEntries = await request
				.param(key, newIds)
				.limit(newIds.length)
				.get()
			return { entries: mapEntries(newEntries, { key }) }
		} catch (err) {
			return { entries: {}, err }
		}
	}

	return { entries: {} }
}
